import { render, staticRenderFns } from "./Spareparts.vue?vue&type=template&id=0dc48c9c&"
import script from "./Spareparts.vue?vue&type=script&lang=js&"
export * from "./Spareparts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports